import { FC } from 'react'
import HistoryListBlock from '../../blocks/HistoryListBlock/HistoryListBlock'
import { Lead } from '@/api/types/crm.types'

interface WideHistoryContentProps {
  lead: Lead
}

const WideHistoryContent: FC<WideHistoryContentProps> = ({ lead }) => {
  return <HistoryListBlock lead={lead} />
}

export default WideHistoryContent
